<div class="logo-container main-container--row justify-center">
  <div
    class="main-container--row--column main-col-12 justify-center">
    @if (!customRouterLink) {
      <a class="logo" [routerLink]="'/'">
        <img src="./assets/logo.svg" alt="Sushi Poznań Drzewo Wiśni - restauracja japońska w Poznaniu Stary Rynek, sushi bar, kuchnia japońska, Sushi na dowóz Poznań" />
      </a>
    }
    @if (customRouterLink) {
      <a class="logo" [routerLink]="customRouterLink">
        <img src="./assets/logo.svg" alt="Sushi Poznań Drzewo Wiśni - restauracja japońska w Poznaniu Stary Rynek, sushi bar, kuchnia japońska, Sushi na dowóz Poznań" />
      </a>
    }
    @if (showMenuIcon && !isOpenMenu && !isAdmin) {
      <div class="menu-icon">
        <img src="./assets/menu/menu.svg" alt="Ikona menu" (click)="openMenu()" />
      </div>
    }
  </div>
</div>
